import React, { useState, useEffect } from 'react';

import PresentationWidget from './presentation-widget';

import PrimusMoneyDidWidgetService from '../model/did-widget-service.js';

const VerifierView = ({root, params}) => {
	const [build_version, setBuildVersion] = useState('unknown');

	const [did_widget_params, setWidgetParams] = useState({
		description: "verifier did widget specification",
		widget: "connect"
	});

	const [remote_widget_params_endpoint, setRemoteWidgetParamsEndpoint] = useState(null);

	const [widget_client_id, setWidgetClientId] = useState(null);

	const [last_change_on, setLastChangeOn] = useState(Date.now());

	const [loaded, setIsLoaded] = useState(false);


	const _loadComponent = async () => {
		try {
			let boot_config = params.config;

			let _did_widget_params = Object.assign({}, params.widget_params);

			// then read widget params with deployment
			let default_widget_params = (boot_config && boot_config.default_widget_params ? boot_config.default_widget_params : {});

			if (default_widget_params)
			Object.assign(_did_widget_params, default_widget_params);

			// see if there is a remote overload
			if (params && params.config && params.config.remote_config_endpoint) {
				let _conf = await root.fetchJson(params.config.remote_config_endpoint);

				if (_conf && _conf.remote_widget_params_endpoint) {
					let widget_params_endpoint = _conf.remote_widget_params_endpoint;
					setRemoteWidgetParamsEndpoint(widget_params_endpoint);	
				}
			}

			// set widget params in component
			setWidgetParams(_did_widget_params);
			setLastChangeOn( Date.now()); // will change key of MyDidWidget to force remounting

			setBuildVersion(params.build_version);

			const _widget_uuid = PrimusMoneyDidWidgetService.guid();
			const _widget_client_id = 'MyDidWidgetClient-' + _widget_uuid;
			console.log('setting widget_client_id to ' + _widget_client_id + ' old id is  ' + widget_client_id);
			setWidgetClientId(_widget_client_id);

			setIsLoaded(true);

		}
		catch(e) {
			console.log('exception in VerifierView._loadComponent: ' + e);
		}
	};


	// componentDidMount
	useEffect(() => {
		_loadComponent().catch(err => {});
	}, []); // end of useEffect


	return (

		<div className="Pane">
		<h1>Verifying you're 18+</h1>
		{(loaded === false ? 
		<></> :
		<PresentationWidget 
			widget_client_id={widget_client_id}
			did_widget_params = {did_widget_params}
			remote_widget_params_endpoint = {remote_widget_params_endpoint}
			lastchangeon = {last_change_on}
			key = {widget_client_id}
		/>)}
		
		</div>

	);
};
  

export default VerifierView;